import { render } from "./Home.vue?vue&type=template&id=ece97a4c"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import exportComponent from "/home/gitlab-runner/builds/2cee3a96/0/public-projects/simple-editor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__